import Map from "google-map-react";
import {useRecoilValue} from "recoil";

import CurrentLocation from "assets/images/svg/current_location.svg";
import OtherLocation from "assets/images/svg/other_locations.svg";

import {AddressAtom} from "pages/contact-us/contact-us.service";

const Marker = ({icon = CurrentLocation}: any) => <img className='map-icon' src={icon} alt="dexef-logo"/>

export default function AddressMap() {
    const address = useRecoilValue(AddressAtom)

    function getCenter() {
        return address ? {lat: +address.latitude, lng: +address.longitude} : {lat: 29.9565, lng: 31.2601}
    }

    return <div className="map mb-3">
        <Map
            zoom={18}
            center={getCenter()}
            options={{zoomControl: false, fullscreenControl: false, keyboardShortcuts: false,}}
            bootstrapURLKeys={{key: "AIzaSyB_VKEUIGOwssXqLuDQNxd22liPU-j-Uho"}}
            onChildClick={(_, childProps) => {
                window.open(`https://www.google.com/maps/@${childProps.lat},${childProps.lng},15z/data=!4m5!3m4!1s0x0:0x315df5c1d1969d6a!8m2!3d29.9565818!4d31.2601832`)
            }}
        >
            <Marker
                lat={29.9565}
                lng={31.2601}
            />
            <Marker
                lat={30.5629}
                lng={31.1579}
                icon={OtherLocation}
            />
        </Map>
    </div>;
}